import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { dynamicFormModal, updateFormList, saveForm } from "FormBuilderAction";
import { fetchSettings } from "TicketAction";
import FormBuilder from "./form-builder";
import LocaleStrings from "Languages";

class AddForm extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openPreviewModel = this.openPreviewModel.bind(this);
    this.closePreviewModel = this.closePreviewModel.bind(this);
    this.state = { showPreviewModal: false, loading: false };
  }

  componentDidMount() {}

  closeModal() {
    // this.props.reset();
    this.props.dynamicFormModal({ showModal: false });
    this.props.updateFormList([], [], "new");
  }

  openPreviewModel() {
    this.setState({ showPreviewModal: true });
  }

  closePreviewModel() {
    this.setState({ showPreviewModal: false });
  }

  onSubmitForm = () => {
    var { session, oldKeys, formName, formBuilderModal } = this.props;
    var p = "0123456789";
    var formnumber = [...Array(6)].reduce(
      (a) => a + p[~~(Math.random() * p.length)],
      ""
    );
    var version = 1;
    var formid = "";
    var formtype = formBuilderModal.category;

    // Rearrange the taborder if any field is removed or added
    var newArrAvailable = [];
    oldKeys.map((value, index) => {
      newArrAvailable.push({ ...value, taborder: index + 1 });
    });
    var oldKeys = newArrAvailable;

    let unique = [...new Set(oldKeys.map((a) => a.name))]; // Check unique field

    // Below code is commented by Vinay on 12/10/2020 as now we have multiple form type
    // let name_email = _.filter(oldKeys, (obj) => {return (obj.name).toLowerCase() == 'firstname' || (obj.name).toLowerCase() == 'lastname' || (obj.name).toLowerCase() == 'email'}); // Checking if name or email exist or not

    // if(name_email.length > 0) {
    //     this.props.showError(LocaleStrings.dynamic_form_validation_name_email_field_not_required);
    // }

    if (unique.length != oldKeys.length) {
      this.props.showError(
        LocaleStrings.dynamic_form_validation_all_field_should_unique
      );
    } else {
      var values = {
        formid: formid,
        formname: formName,
        formnumber: formnumber,
        versionno: version,
        formtype: formtype,
        formjson: JSON.stringify(oldKeys),
        ispublished: 1,
        ismandatory: 0,
      };

      // We are sending the selected session id for session rating form directly and updating the session table in same api.
      if (formtype === "sessionrating" && formBuilderModal.selectedSession) {
        values.sessionid = formBuilderModal.selectedSession;
      }

      this.setState({ loading: true });
      this.props.saveForm(session, values, (response) => {
        // console.log("response :- ", response);
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(LocaleStrings.dynamic_form_created_success);
          this.props.calledFrom(response.data);
          this.closeModal();
        }
      });
    }
  };

  /**
   * =============================================================================================
   */
  render() {
    var { oldKeys, formBuilderModal } = this.props;
    let disabled = true;
    if (oldKeys && oldKeys.length > 0) {
      disabled = false;
    }

    return (
      <div>
        <div>
          <Modal
            size="xl"
            className="modal-container modalResize checkout-form-modal modalfortab"
            enforceFocus={false}
            show={
              formBuilderModal && formBuilderModal.showModal === true
                ? true
                : false
            }
            animation={true}
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.dynamic_form_text_create_form}
                <div className="custom-text2-secondary-normal"></div>
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body className="scrollable-modal- p-0">
              <div>
                <FormBuilder
                  formBuilderData={formBuilderModal}
                  source={formBuilderModal.category}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                loading={this.state.loading}
                type="submit"
                disabled={disabled}
                onClick={this.onSubmitForm}
              >
                {LocaleStrings.button_save}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        <div>
          <Modal
            className="modal-container"
            show={this.state.showPreviewModal === true ? true : false}
            animation={true}
          >
            <Modal.Body>
              <div style={{ padding: 20 }}>Form Here .....</div>
            </Modal.Body>
            <Modal.Footer>
              <Button className="button-theme" onClick={this.closePreviewModel}>
                {LocaleStrings.button_close}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    oldKeys: state.formList,
    formName: state.formName,
    formBuilderModal: state.formBuilderModal,
  };
}

export default connect(mapStateToProps, {
  dynamicFormModal,
  updateFormList,
  saveForm,
  showError,
  showSuccess,
  fetchSettings,
})(AddForm);
